import React from "react";

function Pagination({
  page,
  totalPages,
  onPageChange,
}) {

  return (
    <div className="d-flex align-items-center gap-3 mt-4">

      <button
        className="btn btn-primary"
        disabled={page === 1}
        onClick={() =>
          onPageChange(page - 1)
        }
      >
        Prev
      </button>

      <span>
        Page {page} of {totalPages}
      </span>

      <button
        className="btn btn-primary"
        disabled={page === totalPages}
        onClick={() =>
          onPageChange(page + 1)
        }
      >
        Next
      </button>

    </div>
  );
}

export default Pagination;